import React from 'react'
import MenuItem from 'material-ui/MenuItem'
import api from '../../api'

const buildMenuItems = (resource) => {
  const disabled = resource.status === 'failed'

  const downloadFile = () => {
    api.get(`admin/member_import_logs/download/${resource.id}`)
      .then(res => res.json())
      .then(json => {
        window.open(json.url, '_blank')
      })
  }

  return [
    <MenuItem primaryText='File Details' key='detail' value={`/security/log-history/${resource.id}/detail`} />,
    <MenuItem
      primaryText='Download File'
      key='download'
      onClick={downloadFile}
      disabled={disabled}
    />
  ]
}

export default buildMenuItems
